import { mergeStyles } from "@uifabric/styling";
import { memoizeFunction } from "@uifabric/utilities";
var getClassNames = memoizeFunction(function (styles, className) {
    return {
        root: mergeStyles("window-portal", className, styles.root)
    };
});
export { getClassNames };
